var React = require('react');

function IconPlay2 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".play{fill:#fff;}")),React.createElement("title",{"key":1},"Artboard 9 copy 2"),React.createElement("path",{"className":"play","d":"M2.74,27.25C2.6,14,13.74,2.86,27.35,2.74A24.75,24.75,0,1,1,2.74,27.25ZM20.81,40.17,40.92,27.48,20.81,14.8Z","key":2})]);
}

IconPlay2.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 54.97 54.97"};

module.exports = IconPlay2;

IconPlay2.default = IconPlay2;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/assets/Icon_Play2.svg
// module id = 530
// module chunks = 0